import { TagAutomation, TagNeedsReview } from '../api/models';
import Emails from '../components/Emails';

export default function AutomationEmails() {
  return <Emails title="Automation" filterAllTags={`${TagAutomation},${TagNeedsReview}`} description="Automation emails that still need review." />;
}
